import { Chip, ChipSize, ChipVariant } from '@hourly-hds/components';

type ReferralStatus =
  | 'Referred'
  | 'Pending Acceptance'
  | 'Pending Assignment'
  | 'Account Setup'
  | 'Compliance Block'
  | 'Pending Compliance'
  | 'Pending First Payroll Run'
  | 'Missing Information'
  | 'Lost'
  | 'Archived'
  | 'Active';

const ReferralStatusChip = ({ status }: { status: ReferralStatus }) => {
  const variantMap: Record<ReferralStatus, ChipVariant | undefined> = {
    Referred: undefined,
    'Pending Acceptance': ChipVariant.Warning,
    'Pending Assignment': ChipVariant.Information,
    'Account Setup': ChipVariant.Information,
    'Compliance Block': ChipVariant.Error,
    'Pending Compliance': ChipVariant.Warning,
    'Pending First Payroll Run': ChipVariant.Success,
    'Missing Information': ChipVariant.Warning,
    Lost: ChipVariant.Error,
    Archived: ChipVariant.Error,
    Active: ChipVariant.Success,
  };

  return (
    <Chip size={ChipSize.Large} variant={variantMap[status]}>
      {status}
    </Chip>
  );
};

export default ReferralStatusChip;
